import { combineReducers } from 'redux'
import { createStore } from 'redux'
import adminReducer from './admin/reducer'
import appReducer from './app/reducer'
import authReducer from './auth/reducer'
import documentMutatorReducer from '../repo/components/DocumentMutator/reducer'
import floorWardenReducer from './floorWarden/reducer'
import libraryReducer from './library/reducer'
import notificationsReducer from './notifications/reducer'
import playlistMutatorReducer from './playlistMutator/reducer'
import quizMutatorReducer from './quizMutator/reducer'
import trainingProgramReducer from './trainingProgram/reducer'
import uploadManagerReducer from '../components/UploadManager/reducer'
import videoMutatorReducer from './videoMutator/reducer'

const rootReducer = combineReducers({
    admin: adminReducer,
    app: appReducer,
    auth: authReducer,
    documentMutator: documentMutatorReducer,
    floorWarden: floorWardenReducer,
    library: libraryReducer,
    notifications: notificationsReducer,
    playlistMutator: playlistMutatorReducer,
    quizMutator: quizMutatorReducer,
    trainingProgram: trainingProgramReducer,
    uploadManager: uploadManagerReducer,
    videoMutator: videoMutatorReducer,
})

export const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export const dispatch = (action) => {
    const { type, ...rest } = action
    //console.log(`λ ${type}`, { ...rest })
    store.dispatch(action)
    //console.log('λ ', store.getState())
   // console.log('\n')
}
